import { createSelector } from '@ngrx/store';

import { IBackAuthState } from '../auth.state';
import { getBackAuthState } from '../auth.selectors';
import { BackAuthUsersFeatureKey, IBackAuthUsersState } from './users.state';

export const getBackAuthUsersState = createSelector(
    getBackAuthState,
    (state: IBackAuthState) =>
        state[BackAuthUsersFeatureKey]
);

export const getSelectedUser = createSelector(
    getBackAuthUsersState,
    (state: IBackAuthUsersState) =>
        state.global.selected
);
export const getBackUsersFilter = createSelector(
    getBackAuthUsersState,
    (state: IBackAuthUsersState) =>
        null // state.oData.filter
);
